import React from 'react';
import { useSelector } from 'react-redux';
import { format, isToday, isYesterday } from 'date-fns';
import UserProfilePic from '../common/UserProfilePic';

const ChatListItem = ({ chat, isActive, onClick }) => {
  const { typingUsers } = useSelector(state => state.chat || { typingUsers: {} });
  const isTyping = typingUsers[chat.id] || false;
  
  // Format date display
  const formatMessageDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    
    if (isToday(date)) {
      return format(date, 'h:mm a');
    } else if (isYesterday(date)) {
      return 'Yesterday';
    } else {
      return format(date, 'MMM d');
    }
  };
  
  // Format display name
  const displayName = chat.merchantInfo?.storeName || chat.username || "User";
  
  // Truncate message preview
  const messagePreview = chat.lastMessage && chat.lastMessage.length > 35
    ? `${chat.lastMessage.substring(0, 35)}...`
    : chat.lastMessage;
  
  return (
    <div 
      className={`cursor-pointer transition-colors ${
        isActive 
          ? 'bg-brand-teal-light bg-opacity-10 border-l-4 border-brand-teal pl-3' 
          : 'hover:bg-gray-50 pl-4'
      }`}
      onClick={onClick}
    >
      <div className="flex items-center py-3 pr-4">
        <div className="flex-shrink-0">
          <UserProfilePic 
            user={chat}
            className="w-10 h-10" 
            altText={displayName}
          />
        </div>
        
        <div className="ml-3 flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <h3 className={`text-sm font-medium ${isActive ? 'text-brand-teal-dark' : 'text-gray-900'} truncate max-w-[120px]`}>
              {displayName}
            </h3>
            {chat.lastMessageDate && (
              <span className="text-xs text-gray-500">
                {formatMessageDate(chat.lastMessageDate)}
              </span>
            )}
          </div>
          
          <div className="mt-1">
            {isTyping ? (
              <p className="text-xs text-brand-teal font-medium">typing...</p>
            ) : (
              <p className="text-xs text-gray-500 truncate">{messagePreview || 'No messages yet'}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatListItem; 